export const XBIT_RELAY_PROVIDER_AUDIT_PERMISSION_RESOURCE = 'xbit-relay:provider-audit';
export const XBIT_RELAY_PROVIDER_AUDIT_CREATE_CORRECTION_ACTION = 'create-correction';
export const XBIT_RELAY_PROVIDER_AUDIT_UNLOCK_ACTION = 'unlock';

export const PROVIDER_AUDIT_FLOWS = ['deposit', 'withdraw'] as const;

export const PROVIDER_AUDIT_TABS = ['mismatches', 'locks'] as const;

/**
 * Data-provider key for the Locks tab only — deliberately NOT a routable `<Resource>`.
 * `AppDataProvider` dispatches on this string, and the tab passes it to `<List resource>`.
 */
export const PROVIDER_AUDIT_LOCKS_RESOURCE = 'xbit-relay/provider-audit-locks';

// BE caps pageSize at 200.
export const PROVIDER_AUDIT_ROWS_PER_PAGE = [10, 20, 50, 100, 200];
